import { Address } from '@liberty-financial/agp-shared';

import { SparkAddress } from '@shared/models/address';
import {
  OptionsPropertyDefinition,
  StringPropertyDefinition
} from '@shared/models/schema-property-definition';
import { IdObjectValue } from '@shared/models/schema-property-definition/id-value/id-object-value';

import { ClientAddress } from '../address';

export namespace Residence {
  export interface SchemaPropertyDefinition {
    address: ClientAddress.SchemaPropertyDefinition;
    addressType: OptionsPropertyDefinition;
    residentialStatus: OptionsPropertyDefinition;
    startDate: StringPropertyDefinition;
    endDate: StringPropertyDefinition;
  }

  export type CollectionSchemaContract =
    IdObjectValue.SchemaContractCollection<{
      address: SparkAddress.SchemaContract | null;
      addressType?: string | null;
      residentialStatus?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      new: boolean | null;
    }>;

  export interface Model extends IdObjectValue.Crud.Updatable {
    address: Address | null;
    addressType?: string | null;
    residentialStatus?: string | null;
    startDate?: string | null;
    endDate?: string | null;
  }

  export function toModel(values: CollectionSchemaContract): Model[] {
    return IdObjectValue.Crud.toNativeArray(values, (x) => ({
      created: x.new ?? false,
      deleted: x.deleted,
      id: x.id,
      address: SparkAddress.toModel(x.address),
      addressType: x.addressType,
      residentialStatus: x.residentialStatus,
      startDate: x.startDate,
      endDate: x.endDate
    }));
  }

  export function toSchemaContracts(values: Model[]): CollectionSchemaContract {
    return IdObjectValue.Crud.toIdObjectValueSchemaCollection(values, (x) => ({
      address: SparkAddress.toSchemaContract(x.address),
      addressType: x.addressType,
      residentialStatus: x.residentialStatus,
      startDate: x.startDate,
      endDate: x.endDate,
      new: null
    }));
  }
}
